import React, { FC, useContext } from 'react';
import { Box, FormGroup, useMediaQuery, useTheme } from '@mui/material';
import CustomRating from '../CustomRating/CustomRating';
import { useTranslation } from 'react-i18next';
import { LocalTranslationContext } from '../../hooks/useLocalTranslation';

interface Props {
  question: any;
  step: number;
  onChange: (qid: string, val: string, i: number, p: boolean) => Promise<void>;
  value?: string;
  currentLanguage: string;
}

const CustomQuestionScalenps: FC<Props> = ({ question, step, onChange, currentLanguage }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const localContext = useContext(LocalTranslationContext);
  const { t: globalT } = useTranslation();
  const t = localContext ? localContext.t : globalT;

  let highText;
  let lowText;

  function getTranslatedOption(idx: number) {
    return (
      question?.questionI18n?.options?.[currentLanguage]?.[idx] ??
      question.options?.[idx]?.label ??
      ''
    );
  }

  highText = getTranslatedOption(1) || globalT('nps_high');
  lowText = getTranslatedOption(0) || globalT('nps_low');

  return (
    <Box className="survey-custom-question survey-custom-question--scale-nps">
      <FormGroup className="survey-answer-form-group">
        <CustomRating
          highText={highText}
          lowText={lowText}
          min={0}
          max={10}
          isSmallScreen={isSmallScreen}
          onRatingClick={async (rating) => {
            await onChange(question.questionId || '', '' + rating, step, false);
          }}
          currentRating={-1}
        />
      </FormGroup>
    </Box>
  );
};

export default CustomQuestionScalenps;
